// Original category artwork recovered from the old Temples of India server.
const categoryImages = {
  culture: "culture.jpg",
  "dharm-prachar": "dharm-prachar.png",
  education: "education.jpg",
  environment: "environment.png",
  "gram-vikas": "gram-vikas.jpg",
  "jeev-seva": "jeev-seva.png",
  media: "media.png",
  research: "research.png",
  temples: "temples.png",
}

// Keep recovered logos on this site rather than hotlinking moved assets.
const organizationLogos = {
  "anaadi foundation": "/images/organizations/anaadi-foundation.png",
  "dharma dispatch": "/images/organizations/dharma-dispatch.png",
  "temples of india": "/images/organizations/temples-of-india.svg",
}

const unavailableLogos = new Set([
  "https://dopolitics.in/wp-content/themes/politics/images/do-politics-logo.svg",
  "https://www.ayngaranfoundation.org/assets/images/logo_ayngaran_foundation.png",
  "https://www.reclaimtemples.org//images/logo.png",
])

function getOrganizationLogo(name, url, logo) {
  const key = (name || "").trim().toLowerCase()
  if (Object.prototype.hasOwnProperty.call(organizationLogos, key)) {
    return organizationLogos[key]
  }
  const source = logo?.localFiles?.[0]?.publicURL || url || logo?.raw?.[0]?.url || ""
  // A corrected URL in Airtable can replace an unavailable source normally.
  return unavailableLogos.has(source) ? "" : source
}

function getCategoryImage(slug, original) {
  const name = slug.split("/").filter(Boolean).pop()
  return Object.prototype.hasOwnProperty.call(categoryImages, name)
    ? `/images/categories/${categoryImages[name]}`
    : original || ""
}

function getInitials(name) {
  return (name || "").trim().split(/\s+/).filter(Boolean)
    .slice(0, 2).map(word => word[0]).join("").toUpperCase() || "?"
}

module.exports = { getOrganizationLogo, getCategoryImage, getInitials }
